import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import LoadingProgress from '../components/LoadingProgress'

import { fetchRules, fetchRule } from '../actions/rules'

import ErrorMessage from '../components/ErrorMessage'
import RulesList from '../components/RulesList'
import RuleAddForm from '../forms/RuleAddForm'
import RuleEditForm from '../forms/RuleEditForm'
import '../styles/RulesView.css'

class RulesView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showAddModal: false,
      showEditModal: false
    }

    this.refreshRules = this.refreshRules.bind(this)
    this.toggleAddModal = this.toggleAddModal.bind(this)
    this.toggleEditModal = this.toggleEditModal.bind(this)
    this.openEditModal = this.openEditModal.bind(this)
  }

  componentDidMount() {
    this.props.fetchRules()
  }

  refreshRules() {
    this.props.fetchRules()
  }

  toggleAddModal() {
    this.setState({ showAddModal: !this.state.showAddModal })
  }

  toggleEditModal() {
    this.setState({ showEditModal: !this.state.showEditModal })
  }

  openEditModal(id) {
    // Load the rule into the store BEFORE mounting the edit form,
    // so it always initializes with the freshly selected rule.
    this.props.fetchRule(id)
      .then(() => this.setState({ showEditModal: true }))
      .catch((error) => console.error(error))
  }

  renderRules() {
    const { rules, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!rules || loading) {
      return <LoadingProgress />
    }

    return (<RulesList rules={rules} onEdit={this.openEditModal} />)
  }

  render() {
    const { showAddModal, showEditModal } = this.state

    return (
      <div className="rules-view">
        {/* Header Section */}
        <div className="rules-header">
          <div className="rules-title-section">
            <h1 className="rules-title">
              <i className="fas fa-pencil-ruler"></i>
              REGLAS DE NEGOCIO
            </h1>
          </div>
          <div className="rules-actions">
            <button type="button" className="btn btn-vw btn-action" onClick={this.toggleAddModal}>
              <i className="fas fa-plus mr-2"></i>
              Nueva
            </button>
          </div>
        </div>

        {this.renderRules()}

        {/* Add Rule Modal */}
        <Modal isOpen={showAddModal} toggle={this.toggleAddModal} size="lg" className="op-modal">
          <ModalHeader toggle={this.toggleAddModal}>
            <span className="text-vw-dark">NUEVA </span>
            <span className="text-vw-light">REGLA DE NEGOCIO</span>
          </ModalHeader>
          <ModalBody>
            <RuleAddForm
              isModal={true}
              closeModal={this.toggleAddModal}
              refreshRules={this.refreshRules}
            />
          </ModalBody>
        </Modal>

        {/* Edit Rule Modal */}
        <Modal isOpen={showEditModal} toggle={this.toggleEditModal} size="lg" className="op-modal">
          <ModalHeader toggle={this.toggleEditModal}>
            <span className="text-vw-dark">EDITAR </span>
            <span className="text-vw-light">REGLA DE NEGOCIO</span>
          </ModalHeader>
          <ModalBody>
            <RuleEditForm
              isModal={true}
              closeModal={this.toggleEditModal}
              refreshRules={this.refreshRules}
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  rules: state.rules.rules,
  error: state.rules.error,
  loading: state.rules.loading,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchRules: bindActionCreators(fetchRules, dispatch),
  fetchRule: bindActionCreators(fetchRule, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(RulesView)
